import type { StoreApi, UseBoundStore } from "zustand";

export function storeSelectorGetter<T extends Record<string, unknown>>(
  store: UseBoundStore<StoreApi<T>>,
): { [K in keyof T]: (state: T) => T[K] } {
  return Object.keys(store.getState()).reduce(
    (selectors, key) => {
      selectors[key as keyof T] = (state: T) => state[key] as T[keyof T];
      return selectors;
    },
    {} as { [K in keyof T]: (state: T) => T[K] },
  );
}
